import {
  ChatBubbleOvalLeftEllipsisIcon,
  Cog8ToothIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
} from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { CornerUpLeft } from 'lucide-react';
import type React from 'react';

import type { MainTabKey } from '@/sections/poe/types/poe.types';

// Export for use in TabDescription component
export const MAIN_TAB_DEFS: Record<
  MainTabKey,
  {
    id: string;
    label: string;
    heading: string;
    icon: React.ComponentType<{ className?: string }>;
    description: string;
  }
> = {
  INFORMATION: {
    id: 'information',
    label: 'Information',
    heading: 'Auxiliary Information',
    icon: InformationCircleIcon,
    description: 'Auxiliary information about the vulnerability',
  },
  REQUEST: {
    id: 'request',
    label: 'Request',
    heading: '',
    icon: ChatBubbleOvalLeftEllipsisIcon,
    description: 'Raw request that triggered the vulnerability detection',
  },
  RESPONSE: {
    id: 'response',
    label: 'Response',
    heading: '',
    icon: CornerUpLeft,
    description: 'Server response confirming the vulnerability',
  },
  DETECTION: {
    id: 'detection',
    label: 'Detection',
    heading: '',
    icon: ShieldExclamationIcon,
    description: 'How this vulnerability was detected and matched',
  },
  ATTRIBUTES: {
    id: 'attributes',
    label: 'Attributes',
    heading: '',
    icon: Cog8ToothIcon,
    description: 'Endpoints and other details attributed to this risk',
  },
  LOGIN_PANEL: {
    id: 'login_panel',
    label: 'Login Panel',
    heading: 'Login Panel',
    icon: ShieldExclamationIcon,
    description: 'A login panel was detected by Chariot',
  },
  REMEDIATION: {
    id: 'remediation',
    label: 'Remediation',
    heading: 'Suggested Remediation',
    icon: CheckCircleIcon,
    description: 'Steps to fix or mitigate this vulnerability',
  },
};
